import { ArrowsClockwise, CheckCircle } from "@phosphor-icons/react";

/**
 * Audio approval card shown in SongDetail after Suno finishes the song.
 * Once the user clicks "Sí, me gustó" the card is replaced by a small badge.
 * Approval persists in localStorage and is invalidated when audio_url changes.
 */
export const AudioApprovalCard = ({
  approved,
  regenInfo,
  loading,
  onApprove,
  onModify,
}) => {
  if (approved) {
    return (
      <div className="rounded-2xl bg-[#B4F34A]/10 border border-[#B4F34A]/30 p-3 mb-5 flex items-center justify-center gap-2" data-testid="audio-approved-badge">
        <CheckCircle weight="fill" size={18} className="text-[#B4F34A]" />
        <span className="text-sm text-[#B4F34A] font-semibold">Canción autorizada por ti</span>
      </div>
    );
  }

  const audioInfo = regenInfo?.kinds?.audio || {};
  const isFreeNext = !!audioInfo.is_free_next;
  const credits = regenInfo?.regen_credits || 0;

  return (
    <div className="rounded-2xl bg-gradient-to-br from-[#0e1d10] to-[#0a0a0a] border border-[#B4F34A]/30 p-5 mb-5" data-testid="audio-approval-card">
      <p className="font-display font-bold text-lg mb-1 text-center">¿Te gustó cómo quedó?</p>
      <p className="text-xs text-white/55 text-center mb-4">
        Escúchala con calma. Cuando estés conforme, autorízala. Si no, puedes pedir una nueva versión.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={onApprove}
          className="flex-1 py-4 rounded-full bg-[#B4F34A] hover:bg-[#A0E03A] text-black font-bold transition-all active:scale-95 flex items-center justify-center gap-2"
          data-testid="btn-approve-audio"
        >
          <CheckCircle weight="fill" size={20} /> Sí, me gustó
        </button>
        <button
          onClick={onModify}
          disabled={loading}
          className="flex-1 py-4 rounded-full bg-transparent border-2 border-[#FFB800] text-[#FFB800] hover:bg-[#FFB800]/10 font-bold transition-all active:scale-95 flex items-center justify-center gap-2 disabled:opacity-50"
          data-testid="btn-modify-audio"
        >
          <ArrowsClockwise weight="bold" size={18} /> Quiero modificar la música
        </button>
      </div>
      <p className="text-[11px] text-white/40 text-center mt-3">
        {isFreeNext
          ? <>🎁 <span className="text-[#B4F34A] font-semibold">Tienes 1 cambio gratis</span> incluido en tu paquete.</>
          : credits > 0
            ? <>Cambios extra disponibles: <span className="text-white font-semibold">{credits}</span> · cada cambio cuesta $20 MXN.</>
            : <>Sin cambios gratis ni extra. Otra versión costará comprar 1 cambio extra ($20 MXN).</>}
      </p>
    </div>
  );
};
